module.exports = __webpack_public_path__ + "img/33.2115cc9e.jpg";